import type { Template } from "@/types";

export const PO_03_H2_V1: Template[] = [
    {
        id: "po-03-h2v2-01",
        name: "PO 01 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 219, width: 515, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 523, y: 219, width: 253, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 219, width: 515, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-02",
        name: "PO 02 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 57, y: 237, width: 469, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 237, width: 230, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 772, y: 237, width: 467, height: 354, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-03",
        name: "PO 03 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 219, width: 515, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 523, y: 219, width: 515, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1046, y: 219, width: 253, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-04",
        name: "PO 04 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 110, y: 154, width: 824, height: 518, rotation: 0, imageRotation: 0 },
            { id: "2", x: 942, y: 154, width: 247, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 942, y: 515, width: 247, height: 157, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-05",
        name: "PO 05 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 187, y: 100, width: 474, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 187, y: 417, width: 474, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 668, y: 100, width: 442, height: 626, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-06",
        name: "PO 06 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 88, y: 100, width: 474, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 417, width: 474, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 753, y: 100, width: 442, height: 627, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-07",
        name: "PO 07 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 61, y: 65, width: 526, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 418, width: 526, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 65, width: 491, height: 698, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-08",
        name: "PO 08 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 104, y: 100, width: 442, height: 627, rotation: 0, imageRotation: 0 },
            { id: "2", x: 737, y: 100, width: 474, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 737, y: 417, width: 474, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-09",
        name: "PO 09 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 219, width: 252, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 260, y: 219, width: 515, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 219, width: 515, height: 390, rotation: 0, imageRotation: 0 }
        ],
    }
];